import moment from "moment";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  List,
  ListItem,
  ListItemText,
  Box,
} from "@mui/material";
import groupBy from "../../common/groupBy";
import MEALS from "./MEALS.json";

const styles = {
  tableHead: {
    borderTop: "1px solid #e0e0e0",
    borderRight: "1px solid #e0e0e0",
    borderLeft: "1px solid #e0e0e0",
    "& th": {
      fontWeight: 800,
      textAlign: "center",
      background: "#eee",
      "& span": {
        display: "block",
        fontWeight: 400,
        fontSize: "0.8rem",
        opacity: 0.5,
        "&:before": { content: "'('" },
        "&:after": { content: "')'" },
      },
    },
  },
  tableCell: {
    verticalAlign: "top",
    textAlign: "center",
    fontSize: "10pt",
    borderRight: "1px solid #e0e0e0",
  },
  tableCellMeal: {
    verticalAlign: "top",
    textAlign: "center",
    fontSize: "10pt",
    paddingTop: "22px",
    fontWeight: 800,
    background: "#eee",
    borderLeft: "1px solid #e0e0e0",
    "& span": {
      opacity: 0.5,
      fontSize: "0.8rem",
      fontWeight: 400,
    },
  },
  mealList: {
    padding: 0,
    "& li": {
      padding: 0,
    },
    "& .MuiTypography-root": {
      fontSize: "10pt",
    },
  },
  planSource: {
    padding: "6px 0",
    opacity: 0.5,
    fontSize: "0.8rem",
    textAlign: "center",
  },
};

const MealItem = ({ data }) => {
  const { amount, dish, unit } = data;

  let amountWithUnit = null;
  if (amount) {
    amountWithUnit = amount;
    if (unit) amountWithUnit += ` ${unit.sign}`;
  }

  return (
    <ListItem>
      <ListItemText primary={dish.name} secondary={amountWithUnit} />
    </ListItem>
  );
};

const MealRow = ({ meal, plan }) => {
  const m = meal.match(/^(\w+)-(\d+)$/, meal);
  const row = groupBy(plan[meal], (item) => moment(item.date).format("dd"));

  return (
    <TableRow key={meal}>
      <TableCell sx={styles.tableCellMeal}>
        {MEALS[m[1]]}
        <br />
        <span>{m[2]}:00</span>
      </TableCell>
      {Object.keys(row).map((day) => (
        <TableCell sx={styles.tableCell} key={`meal-cell-${m[1]}-${day}`}>
          <List sx={styles.mealList}>
            {row[day].map((item) => (
              <MealItem
                key={`meal-item-${day}-${item.meal}-${item.dish.id}`}
                data={item}
              />
            ))}
          </List>
        </TableCell>
      ))}
    </TableRow>
  );
};

const Desktop = ({ planId, data, start, end, week }) => {
  const plan = groupBy(data, (item) => {
    return `${item.meal}-${moment(item.date).format("HH")}`;
  });

  const days = [
    "Ponedeljak",
    "Utorak",
    "Sreda",
    "Četvrtak",
    "Petak",
    "Subota",
    "Nedelja",
  ];
  const dates = [];
  for (let i = start.clone(); i < end; i = i.add(1, "day")) {
    dates.push(i.format("DD.MMM"));
  }

  return (
    <>
      <Box sx={styles.planSource}>Plan #{planId}</Box>
      <Table sx={styles.table}>
        <TableHead sx={styles.tableHead}>
          <TableRow>
            <TableCell></TableCell>
            {days.map((day, i) => (
              <TableCell key={`header-${day}`}>
                {day}
                <span>{dates[i]}</span>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.length === 0 && (
            <TableRow>
              <TableCell colSpan={8} align="center">
                nema rezultata.
              </TableCell>
            </TableRow>
          )}
          {data.length > 0 && (
            <>
              {Object.keys(plan).map((meal) => (
                <MealRow meal={meal} plan={plan} key={meal} />
              ))}
            </>
          )}
        </TableBody>
      </Table>
    </>
  );
};

export default Desktop;
